// extracted by mini-css-extract-plugin
export default {"formWrapper":"type-of-order-form_formWrapper__O1Rb7","rowWrapper":"type-of-order-form_rowWrapper__RFtyw","actionBtnWrapper":"type-of-order-form_actionBtnWrapper__vu964"};